import { trackEvent } from "../analytics/analytics.js";

export const PARTNER_INVENTORY_ANALYTICS_EVENTS = Object.freeze({
  VIEW_LOADED: "partner_inventory_view_loaded",
  VIEW_TOGGLED: "partner_inventory_view_toggled",
  GROUPED_LOADED: "partner_grouped_inventory_loaded",
  GROUPED_ERROR: "partner_grouped_inventory_error",
  NORMALIZATION_REVIEW_OPENED: "partner_normalization_review_opened",
  MANUAL_NORMALIZE_APPLIED: "partner_manual_normalize_applied",
  BULK_NORMALIZE_STARTED: "partner_bulk_normalize_started",
  BULK_NORMALIZE_COMPLETED: "partner_bulk_normalize_completed",
  VEHICLE_IDENTITY_HEALTH_VIEWED: "partner_vehicle_identity_health_viewed",
});

export function trackPartnerInventoryAnalyticsEvent(eventName, payload = {}) {
  return trackEvent(eventName, {
    sourceComponent: "partner_inventory",
    ...payload,
  });
}
